import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import SecureLS from 'secure-ls';


@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly storage = isPlatformBrowser(this.platformId)
    ? new SecureLS({ encodingType: 'aes', isCompression: false })
    : null;

  set(key: string, value: unknown): void {
    this.storage?.set(key, value);
  }

  remove(key: string): void {
    this.storage?.remove(key);
  }

  get<T = unknown>(key: string): T | null {
    if (!this.storage) {
      return null;
    }

    return this.storage.get(key) as T;
  }

  clear(): void {
    this.storage?.removeAll();
  }
}
